<template>
  <select-response
    :model="value"
    :data="source"
    :loading="false"
    @on-change="onChange"
  ></select-response>
</template>

<script>
export default {
  name: 'ActivitySelectOrderBy',
  props: {
    value: { required: true }
  },
  methods: {
    onChange (v) {
      this.$emit('on-change', v)
    }
  },
  computed: {
    source () {
      return [
        {
          title: this.L10n('order-by-id-desc'),
          id: 1
        },
        {
          title: this.L10n('order-by-id-asc'),
          id: 2
        },
        {
          title: this.L10n('order-by-reminder-date-desc'),
          id: 3
        },
        {
          title: this.L10n('order-by-reminder-date-asc'),
          id: 4
        },
        {
          title: this.L10n('order-by-phase-date-desc'),
          id: 5
        },
        {
          title: this.L10n('order-by-phase-date-asc'),
          id: 6
        },
        {
          title: this.L10n('core-due-date-desc'),
          id: 7
        },
        {
          title: this.L10n('core-due-date-asc'),
          id: 8
        }
      ]
    }
  }
}
</script>
